import { render, staticRenderFns } from "./BaseLogoEn.vue?vue&type=template&id=9c8775e6&scoped=true&"
import script from "./BaseLogoEn.vue?vue&type=script&lang=ts&"
export * from "./BaseLogoEn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8775e6",
  null
  
)

export default component.exports